import type { Api } from '@cocoonspace/types/shared/api'
import type { AxiosInstance, AxiosRequestConfig } from 'axios'

import { defineEndpoint } from '../utils/define-endpoint'

export interface GetAnyAccount {
	uriParams: Api.Operations['getAnyAccount']['parameters']['path']
	response: Api.Operations['getAnyAccount']['responses']['200']['content']['application/json']
}

export const getAnyAccount = (
	axiosInstance: AxiosInstance,
	overideConfig?: AxiosRequestConfig,
) =>
	defineEndpoint<GetAnyAccount>(
		{
			method: 'get',
			url: '/accounts/{accountId}',
			...overideConfig,
		},
		axiosInstance,
	)
